var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isEmpty
    ? _c("div", { staticClass: "dropdown--cart p-3" }, [_vm._m(0)])
    : _c("div", { staticClass: "dropdown--cart" }, [
        _c(
          "ul",
          { staticClass: "productList-list" },
          [
            _vm._l(_vm.basketitems, function(item, index) {
              return _c(
                "li",
                { key: index, staticClass: "productList view-tiny" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "productList-inner",
                      attrs: { href: "/produkt/" + item.productSlug }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "productList-image thumbnail" },
                        [
                          _c("img", {
                            attrs: {
                              src: item.productPictureUrl,
                              alt: item.productName
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "productList-content" }, [
                        _c("div", { staticClass: "productList-desc" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.productName) +
                              "\n        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "productList-price" }, [
                          _vm._v(
                            "\n          " + _vm._s(item.quantity) + " ks,  "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(item.productPrice) + " Kč")
                          ])
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "product-delete-btn",
                      on: {
                        click: function($event) {
                          return _vm.onBasketItemDelete(item)
                        }
                      }
                    },
                    [_c("BIcon", { attrs: { icon: "x-circle" } })],
                    1
                  )
                ]
              )
            }),
            _vm._v(" "),
            _c("li", { staticClass: "summary" }, [
              _c("span", { staticClass: "count-price" }, [
                _vm._v("\n          Celkem "),
                _c("strong", [_vm._v(_vm._s(_vm.basketItemsCount) + " ks")]),
                _vm._v(" za "),
                _c("strong", [_vm._v(" " + _vm._s(_vm.orderSubTotal) + " Kč")])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "dropdown--cart__button empty",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.trashCart($event)
                    }
                  }
                },
                [_vm._v("Vysypat košík")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown--cart__button",
                  attrs: { href: "/cart/" }
                },
                [_vm._v("Objednat")]
              )
            ])
          ],
          2
        )
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("Váš nákupní "),
      _c("strong", [_vm._v("košík je prázdný.")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }